import React, {  createRef, useEffect, useContext, } from 'react'
import { TextBoxLatest } from '../../common/TextBoxLatest/TextBoxLatest'
import { FormHelperText } from '@mui/material';
import { iWebFormField } from '../schema';
import { FieldsContext } from '../WebFormWorkspace';

export const WebFormTextArea = (props: {fieldConfig:iWebFormField,value?:any,editable?:any,idNamespace?:string}) => {
    const { fieldPlaceholder, fieldDescription, fieldLabel, isMandatory,removeRequired, id} = props?.fieldConfig;
    const ref: any = createRef();
    const { errors } = useContext(FieldsContext);
    const errorMsg = errors?.[id];
    const [, forceUpdate] = React.useReducer(x => x + 1, 0);
    useEffect(() => {
    if (errorMsg) {
        forceUpdate(); // re-render so TextBoxLatest re-checks ref value
    }
    }, [errorMsg]);
    useEffect(() => {
        if (props?.value && ref?.current) {
            ref.current.value = props?.value;
        }
        console.log("refref", props?.value);
    }, [props.value]);
    return (
        <div>
            <TextBoxLatest
                multiline={true}
                placeholder={fieldPlaceholder}
                title={fieldLabel}
                required={removeRequired}
                ref={ref}
                id={`${props.idNamespace ? props.idNamespace + '_' : ''}${id}`}
                isMandotary={isMandatory}
                type= {"text"}
                isError={!!errorMsg}
                errorMsg={errorMsg}
                name={`${props.idNamespace ? props.idNamespace + '_' : ''}${id}`}
                InputProps={{
                    "readOnly": !props?.editable,
                }}
            />
            {/* {errorMsg && <FormHelperText>{errorMsg}</FormHelperText>} */}
            {(fieldDescription && fieldDescription.trim() !== "") && <FormHelperText className="helper-text-webform">{fieldDescription}</FormHelperText>}
        </div>
    )
}